import {
    OPEN_AUTH_MODAL, CLOSE_AUTH_MODAL,
    OPEN_UPDATE_PROFILE_MODAL, CLOSE_UPDATE_PROFILE_MODAL,
    OPEN_BULK_ORDER_MODAL, CLOSE_BULK_ORDER_MODAL,
    SET_HISTORY, SET_DELIVERY_LOCATION, SET_NEAREST_OUTLET, SET_SEARCH_TEXT, SET_FOOD_PREFRENCE
} from '../actions/type'

const initialState = {
    history: {},
    deliveryAddress: {
        location: '',
        coordinates: {
            lng: null,
            lat: null
        }
    },
    nearestOutlet: {
        searchCompleted: null,
        id: null
    },
    isAuthModalOpen: null,
    isUpdateProfileModalOpen: false,
    isBulkOrderModalOpen: false,
    searchText: "",
    foodPref: "ALL"
};

export default (state = initialState, action) => {
    switch (action.type) {
        case OPEN_AUTH_MODAL:
            return { ...state, isAuthModalOpen: true }
        case CLOSE_AUTH_MODAL:
            return { ...state, isAuthModalOpen: false }
        case OPEN_UPDATE_PROFILE_MODAL:
            return { ...state, isUpdateProfileModalOpen: true }
        case CLOSE_UPDATE_PROFILE_MODAL:
            return { ...state, isUpdateProfileModalOpen: false }
        case OPEN_BULK_ORDER_MODAL:
            return { ...state, isBulkOrderModalOpen: true }
        case CLOSE_BULK_ORDER_MODAL:
            return { ...state, isBulkOrderModalOpen: false }
        case SET_HISTORY:
            return { ...state, history: action.payload }
        case SET_DELIVERY_LOCATION:
            return { ...state, deliveryAddress: action.payload }
        case SET_NEAREST_OUTLET:
            return {
                ...state,
                nearestOutlet: {
                    searchCompleted: true,
                    id: action.payload
                }
            }
        case SET_SEARCH_TEXT:
            return {
                ...state,
                searchText: action.payload
            }
        case SET_FOOD_PREFRENCE:
            return {
                ...state,
                foodPref: action.payload
            }
        default:
            return state
    }
}